import React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import Menu from '../menu/Menu';
import AppsDropdown from '../appsDropdown/AppsDropdown';
import UserDropdown from '../userDropdown/UserDropdown';

import routes from '../../helpers/ApplicationRoutes';
import * as organizationSelectors from '../../selectors/organizationSelectors';

const OrganizationHeader = ({ classes, organizationId, history }) => {
    const onHomeClick = () => {
        history.push(
            routes.organization.getPath({
                organizationId: organizationId,
            }),
        );
    };

    return (
        <AppBar position="static" color="default">
            <Toolbar>
                <div className={classes.grow}>
                    <Menu />
                    <Typography
                        onClick={onHomeClick}
                        variant="title"
                        className={classes.title}
                        style={{ display: 'flex' }}
                    >
                        <img src="/assets/header.svg" alt="Vizualist" />
                    </Typography>
                </div>
                <AppsDropdown />
                <UserDropdown />
            </Toolbar>
        </AppBar>
    );
};

const mapStateToProps = state => ({
    organizationId: organizationSelectors.getCurrentOrganizationId(state),
});

const style = ({ spacing }) => ({
    grow: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
        marginLeft: -spacing.unit,
    },
    title: {
        marginLeft: spacing.unit,
        cursor: 'pointer',
    },
});

export default withRouter(
    connect(mapStateToProps)(injectSheet(style)(OrganizationHeader)),
);



// WEBPACK FOOTER //
// ./src/containers/header/OrganizationHeader.js